import { ActionTree } from "vuex";
import { StateInterface } from "src/store";
import { LomsStateInterface } from "./state";
import API from "src/services/api/api";
import {
  IAddLomChannel,
  IAddLomEntity,
  ILomChannel,
  ILomEntity,
  ILomItemUpdate,
} from "src/modules/loms/models";

const actions: ActionTree<LomsStateInterface, StateInterface> = {
  async fetchLomsList(
    { commit },
    payload: { limit: number; offset: number; searchText?: string },
  ) {
    try {
      const lomsList = await API.sqlr.idom_get_loms({
        limit: payload.limit,
        offset: payload.offset,
        name: payload.searchText,
      });
      if (payload.offset) {
        commit("pushLomsList", lomsList[0].data || []);
        commit("setTotalCount", lomsList[0].count);
      } else {
        commit("setLomsList", lomsList[0].data || []);
        commit("setTotalCount", lomsList[0].count);
      }
    } catch (e) {}
  },

  async addLom({ commit }, payload: { name: string }) {
    try {
      const data = await API.sqlr.idom_save_lom(payload.name);
      commit("addLomsList", data);
      commit("incrementTotalCont");
    } catch (e: any) {
      return {
        error: {
          message: e.response.data.message,
        },
      };
    }
  },

  async updateLom({ commit, getters }, lom: ILomItemUpdate) {
    try {
      await API.sqlr.idom_save_lom(lom.name, lom.metadata, lom.guid);
      commit("setLomDetail", { ...getters.getLomDetail, ...lom });
      commit("updateNameLomsListItem", { guid: lom.guid, name: lom.name });
    } catch (e: any) {
      return {
        error: {
          message: e.response.data.message,
        },
      };
    }
  },

  async addChannelForLom(
    { commit, getters },
    payload: { loms_channels: IAddLomChannel[]; channels: ILomChannel[] },
  ) {
    try {
      await API.sqlr.idom_save_loms_with_channels(payload.loms_channels);
      commit("setLomDetail", {
        ...getters.getLomDetail,
        channels: [
          ...(getters.getLomDetail.channels || []),
          ...payload.channels,
        ],
      });
    } catch (e: any) {
      return {
        error: {
          message: e.response.data.message,
        },
      };
    }
  },

  async addEntityForLom(
    { commit, getters },
    payload: { loms_entities: IAddLomEntity[]; entities: ILomEntity[] },
  ) {
    try {
      await API.sqlr.idom_save_loms_entities(payload.loms_entities);
      commit("setLomDetail", {
        ...getters.getLomDetail,
        entities: [
          ...(getters.getLomDetail.entities || []),
          ...payload.entities,
        ],
      });
    } catch (e: any) {
      return {
        error: {
          message: e.response.data.message,
        },
      };
    }
  },

  async deleteChannelForLom({ commit }, loms_channels: IAddLomChannel[]) {
    try {
      await API.sqlr.idom_remove_loms_channels(loms_channels);
      commit(
        "deleteChannelFromLom",
        loms_channels.map((channel) => channel.channel_guid),
      );
    } catch (e: any) {
      return {
        error: {
          message: e.response.data.message,
        },
      };
    }
  },

  async deleteEntityForLom({ commit }, loms_entities: IAddLomEntity[]) {
    try {
      await API.sqlr.idom_remove_loms_entities(loms_entities);
      commit(
        "deleteEntityFromLom",
        loms_entities.map((channel) => channel.entity_guid),
      );
    } catch (e: any) {
      return {
        error: {
          message: e.response.data.message,
        },
      };
    }
  },

  async deleteLom({ commit }, guid: string) {
    try {
      await API.sqlr.idom_remove_lom(guid);
      commit("setLomDetail", undefined);
      commit("deleteLomFromList", guid);
    } catch (e: any) {
      return {
        error: {
          message: e.response.data.message,
        },
      };
    }
  },

  async fetchLom({ commit }, guidLom: string) {
    try {
      const data = await API.sqlr.idom_get_lom_with_parameters(guidLom);
      if (data[0]) {
        commit("setLomDetail", data[0]);
        return;
      }
      return {
        status: 404,
        message: "такой ЛОМ не найден",
      };
    } catch (e: any) {
      return {
        status: e.response.status,
        message: e.response.data.message,
      };
    }
  },
};

export default actions;
